import { toast } from "react-toastify";
import { getTrendsCurveData } from "../../app/api/trendCurves";
import { User } from "../../types";
import { getFactoredTrendCurveResponse } from "../commonUtils";
import { getTrendFiltersForGraphs } from "./graphHelperUtils";

import React from "react";
import {
  mappedFilterTypeTrendCurves,
  TrendCurvesFilterType,
} from "../../constants/constants";
import { LineGraphData, TrendItem } from "../../interface/DesignerInterface";

export const generateTrendCurvesS3JSON = async (user: User | null) => {
  try {
    const {
      trendCurveResponse: trendCurvesUnfactoredJSON,
      factoredTrendCurveResponse: trendCurvesJSON,
    } = await formatAndSetDataForTrendCurves("Most Popular", user);

    if (!(trendCurvesUnfactoredJSON && trendCurvesUnfactoredJSON.length)) {
      console.error("No trends Curves Data");
      return null;
    }

    return {
      filterType: "Most Popular",
      trendCurvesJSON,
      trendCurvesUnfactoredJSON,
    };
  } catch (error) {
    console.error("Error while generating image", error, user);
    toast.error("Error while generating image", {
      hideProgressBar: true,
    });
    return null;
  }
};

export const formatAndSetDataForTrendCurves = async (
  filterType: string,
  user: User | null,
  setTrendsCurveData?: React.Dispatch<
    React.SetStateAction<LineGraphData | null>
  >,
  setTrendsCurveRawData?: React.Dispatch<React.SetStateAction<TrendItem[]>>
) => {
  const trendFilters = getTrendFiltersForGraphs();
  const response = await getTrendsCurveData(
    {
      ...trendFilters,
      query_type:
        mappedFilterTypeTrendCurves[filterType as TrendCurvesFilterType],
    },
    user
  );
  const trendCurveResponse = response?.data.lineGraphData;
  if (Array.isArray(trendCurveResponse) && trendCurveResponse.length === 0)
    return { trendCurveResponse, factoredTrendCurveResponse: [] };

  const factoredTrendCurveResponse =
    getFactoredTrendCurveResponse(trendCurveResponse);

  setTrendsCurveData && setTrendsCurveData(factoredTrendCurveResponse);
  setTrendsCurveRawData && setTrendsCurveRawData(trendCurveResponse);
  return { trendCurveResponse, factoredTrendCurveResponse };
};
